import React from 'react'
import { Main } from './components'

const Profile = () => <Main />

export default Profile
